<template>
  <el-dialog
    class="teacher-info-dialog"
    title="教职工宿舍信息"
    :visible.sync="show"
    width="840px"
    :before-close="closed"
  >
    <el-descriptions :column="3" border>
      <el-descriptions-item  label-class-name="descriptions-item__label" label="姓名">
        {{ title.realName }}
      </el-descriptions-item>
      <el-descriptions-item  label-class-name="descriptions-item__label" label="电话">
        {{ title.phone }}
      </el-descriptions-item>
      <el-descriptions-item  label-class-name="descriptions-item__label" label="性别">
        {{ Number(title.sexType) === 1 ? '男' : (Number(title.sexType) === 2 ? '女' : '') }}
      </el-descriptions-item>
      <el-descriptions-item  label-class-name="descriptions-item__label" label="院系/部门">
        {{ title.collegeName|| title.deptName }}
      </el-descriptions-item>
      <el-descriptions-item  label-class-name="descriptions-item__label" label="宿舍楼">
        {{ title.dormitoryName }}{{ title.floorNum }}层
      </el-descriptions-item>
      <el-descriptions-item  label-class-name="descriptions-item__label" label="宿舍">
        {{ title.roomName }}_{{ title.dormitoryBedNo }}号床
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-button @click="closed">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'

export default {
  name: 'teacherInfoDialog',
  mixins: [dialog],
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.teacher-info-dialog{
  .descriptions-item__label {
    width: 100px;
  }
}
</style>
